module.exports = __webpack_public_path__ + "static/img/7-4.7df4452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/7-4.png
// module id = zW3s
// module chunks = 1